import { render } from "./PatientData.vue?vue&type=template&id=24c7eaed&scoped=true&ts=true"
import script from "./PatientData.vue?vue&type=script&lang=ts"
export * from "./PatientData.vue?vue&type=script&lang=ts"

import "./PatientData.vue?vue&type=style&index=0&id=24c7eaed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c7eaed"]])

export default __exports__